import styled from '../../styled-components';
import MarkdownComponent from '../MarkdownComponent';

const ContentCardCopy = styled(MarkdownComponent)`
  margin-bottom: 0;
`;

export default ContentCardCopy;
